/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlHealthzDatastores
 */
export interface ControlHealthzDatastores {
    /**
     * 
     * @type {boolean}
     * @memberof ControlHealthzDatastores
     */
    postgres: boolean;
}

/**
 * Check if a given object implements the ControlHealthzDatastores interface.
 */
export function instanceOfControlHealthzDatastores(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "postgres" in value;

    return isInstance;
}

export function ControlHealthzDatastoresFromJSON(json: any): ControlHealthzDatastores {
    return ControlHealthzDatastoresFromJSONTyped(json, false);
}

export function ControlHealthzDatastoresFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlHealthzDatastores {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'postgres': json['postgres'],
    };
}

export function ControlHealthzDatastoresToJSON(value?: ControlHealthzDatastores | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'postgres': value.postgres,
    };
}

